import { useSetAtom } from 'jotai';

import { AudioVideoTroubleshootActionItemWrapper as BaseAudioVideoTroubleshootActionItem } from '../components/help-modal/AudioVideoTroubleshootActionItemWrapper';
import { useTheme } from '../hooks/useTheme';
import { useInitAvailableDevices } from '../session/devices/useDevices';
import { Theme } from '../state/theme';
import { useContactUs } from '../useContactUs';
import { HelpModal, HelpModalProps } from './HelpModal';
import { ProviderNotHereDescriptionWrapper } from './ProviderNotHereDescriptionWrapper';
import { VisitorDrawerState, visitorDrawerStateAtom } from './state';
import { useRecordProviderNoShowReportCallback } from './waiting-room/useRecordProviderNoShowReportCallback';

export function HelpModalWrapper(
  props: Omit<
    HelpModalProps,
    | 'audioVideoTroubleshootActionItem'
    | 'isPastNoShowThreshold'
    | 'clientJoinedAfterWindowToReport'
    | 'recordProviderNoShowAndRedirect'
    | 'isDarkTheme'
    | 'contactUsUrl'
    | 'providerNotHereDescriptionComponent'
  >,
) {
  useInitAvailableDevices();
  const { pageUrl } = useContactUs();
  const { theme } = useTheme();
  const setDrawerState = useSetAtom(visitorDrawerStateAtom);
  const openSettings = () => {
    props.onClose();
    setDrawerState(VisitorDrawerState.SETTINGS);
  };
  const { isPastNoShowThreshold, clientJoinedAfterWindowToReport, recordProviderNoShowAndRedirect } =
    useRecordProviderNoShowReportCallback();

  return (
    <HelpModal
      providerNotHereDescriptionComponent={ProviderNotHereDescriptionWrapper}
      isDarkTheme={theme === Theme.DARK}
      contactUsUrl={pageUrl}
      isPastNoShowThreshold={isPastNoShowThreshold}
      clientJoinedAfterWindowToReport={clientJoinedAfterWindowToReport}
      recordProviderNoShowAndRedirect={recordProviderNoShowAndRedirect}
      audioVideoTroubleshootActionItem={<BaseAudioVideoTroubleshootActionItem onOpenSettings={openSettings} />}
      {...props}
    />
  );
}
